export default "__VITE_ASSET__DDLmz_3W__"